import PropTypes from 'prop-types'

import { EMPTY_STEP_METRICS, formatCount } from './campaignFlowMock'
import styles from './OtaBuster.module.scss'

function GuestsIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 18 18" fill="none" aria-hidden="true">
      <path
        d="M6.5 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM12.75 8.5a2 2 0 100-4 2 2 0 000 4zM3 14.25c0-1.933 1.567-3.5 3.5-3.5h.5c1.933 0 3.5 1.567 3.5 3.5V15H3v-.75zM11.25 12c.69 0 1.326.212 1.857.573A3.48 3.48 0 0115 14.25V15h-2.5v-.75c0-.86-.28-1.655-.75-2.3.39-.3.86-.45 1.25-.45z"
        fill="currentColor"
      />
    </svg>
  )
}

function HiBubbleIcon({ color }) {
  return (
    <svg
      className={styles.stepIcon}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      aria-hidden="true"
    >
      <rect width="40" height="40" rx="10" fill={color} fillOpacity="0.14" />
      <path
        d="M10 14.5c0-2.485 2.015-4.5 4.5-4.5h11c2.485 0 4.5 2.015 4.5 4.5v7c0 2.485-2.015 4.5-4.5 4.5h-4.2l-3.7 3.2a.75.75 0 01-1.22-.58V26H14.5C12.015 26 10 23.985 10 21.5v-7z"
        fill={color}
      />
      <text
        x="20"
        y="21.5"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="#fff"
        fontSize="10"
        fontWeight="700"
        fontFamily="system-ui, sans-serif"
      >
        Hi
      </text>
    </svg>
  )
}

HiBubbleIcon.propTypes = {
  color: PropTypes.string.isRequired
}

function CampaignStepCard({
  step,
  metrics,
  preview,
  isActive,
  hasEmailCampaign,
  onEdit,
  onEnable,
  onPreviewSavibook
}) {
  const cardClassNames = [styles.stepCard, !isActive && styles.stepCardInactive]
    .filter(Boolean)
    .join(' ')

  return (
    <article
      className={cardClassNames}
      data-testid={`ota-buster-step-${step.id}`}
      onClick={onEdit}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          onEdit?.()
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className={styles.stepMain}>
        <HiBubbleIcon color={step.iconColor} />
        <div className={styles.stepCopy}>
          {!hasEmailCampaign && (
            <span className={styles.emailNotConfigured}>Email not configured</span>
          )}
          <div className={styles.channelBadge}>Email</div>
          <h3 className={styles.stepTitle}>{step.title}</h3>
          <p className={styles.stepPreview}>{preview}</p>
          <div className={styles.stepActions}>
            <button
              type="button"
              className={styles.previewButton}
              onClick={event => {
                event.stopPropagation()
                onPreviewSavibook(step)
              }}
              data-testid={`ota-buster-preview-${step.id}`}
            >
              Landing Page Preview
            </button>
            <button
              type="button"
              className={styles.editButton}
              onClick={event => {
                event.stopPropagation()
                onEdit?.()
              }}
              data-testid={`ota-buster-edit-${step.id}`}
            >
              Edit email
            </button>
          </div>
        </div>
      </div>
      {isActive ? (
        <div className={styles.stepStats}>
          <div className={styles.statPrimary}>
            <span className={styles.statIconWrap} aria-hidden="true">
              <GuestsIcon />
            </span>
            <span>
              {formatCount(metrics.guests)} guests
              <span className={styles.statMuted}>
                {' '}
                · {formatCount(metrics.emailsSent)} emails sent
              </span>
            </span>
          </div>
          <div className={styles.statSecondary}>
            {metrics.clickThroughRate}% click through rate
          </div>
        </div>
      ) : (
        <div className={styles.inactivePanel}>
          <div className={styles.inactiveTitle}>This step is inactive</div>
          <div className={styles.inactiveDescription}>
            Enable to keep sending this email in the OTA guest journey. Other steps stay
            as they are.
          </div>
          <button
            type="button"
            className={styles.enableButton}
            onClick={event => {
              event.stopPropagation()
              onEnable?.()
            }}
            data-testid={`ota-buster-enable-${step.id}`}
          >
            Enable step
          </button>
        </div>
      )}
    </article>
  )
}

CampaignStepCard.propTypes = {
  step: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    iconColor: PropTypes.string.isRequired
  }).isRequired,
  metrics: PropTypes.shape({
    guests: PropTypes.number,
    emailsSent: PropTypes.number,
    clickThroughRate: PropTypes.number
  }),
  preview: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  hasEmailCampaign: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  onEnable: PropTypes.func,
  onPreviewSavibook: PropTypes.func.isRequired
}

CampaignStepCard.defaultProps = {
  metrics: EMPTY_STEP_METRICS,
  isActive: true,
  hasEmailCampaign: true
}

export default CampaignStepCard
